import React, { FC, useEffect, useState } from "react";
import StayCard from "components/StayCard/StayCard";
import Heading2 from "components/Heading/Heading2";
import useFetch from "hooks/useFetch";
import config from "config.json";
import { useLocation } from "react-router-dom";

export interface SectionGridFilterCardProps {
  className?: string;
}

interface HotelData {
  codigo: string;
  descripcion: string;
  ciudad: string;
  direccion: string;
  precio_por_noche: string;
  cant_lugares: number;
  banios_compartidos: number;
  banios_habitaciones: number;
}

interface HotelImage {
  hotel_code: string;
  photos: string[];
}

interface HotelImageDataResponse {
  default_image: string;
  hoteles: HotelImage[];
}
interface Template {
  
    id: string;
    pagina: string;
    titulo: string;
    descripcion: string;
    cuerpo?: string;

}

const SectionGridFilterCard: FC<SectionGridFilterCardProps> = ({
  className = "",
}) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const selectedCityFromUrl = decodeURIComponent(queryParams.get("city") || "");

  // Fetch para obtener hoteles
  const { data: hotelesData, error: hotelesError, fetchData: fetchHoteles } = useFetch<{ hoteles: HotelData[] }>(
    'GET', `${config.backend_url}/setia/hoteles`, { 'Content-Type': 'application/json' });

  // Fetch para obtener imágenes de los hoteles
  const { data: hotelImagesData, error: hotelImagesError, fetchData: fetchHotelImages } = useFetch<HotelImageDataResponse>(
    'GET', `${config.backend_url}/setia/hoteles/ver_todas_fotos`, { 'Content-Type': 'application/json' });

  const [hoteles, setHoteles] = useState<HotelData[]>([]);
  const [hotelData, setHotelData] = useState<HotelData[]>([]);

  const [hotelImages, setHotelImages] = useState<HotelImage[]>([]);
  const [selectedCity, setSelectedCity] = useState<string>(selectedCityFromUrl || "all");

  const [realizarPeticionTemplate, setRealizarPeticionTemplate] = useState(false)
  const [bodyTemplate, setBodyTemplate] = useState({
    "pagina" : "Inicio",
    "titulo" : "Ciudades",
    "descripcion": ""
  })
  const [templateCiudad, setTemplateCiudad] = useState<Template[] >([])
  const {data: dataTemplate, error: errorTemplate, fetchData: fetchDataTemplate} = useFetch(
    'POST',
    `${config.backend_url}/setia_administrator/template/get`,
    bodyTemplate,
    {}
  )

  useEffect(() => {
    if(dataTemplate){
      const response = dataTemplate as any;
      setTemplateCiudad(response.content)
      
    }
    if(errorTemplate){
      console.log(errorTemplate)
    }
  }, [dataTemplate,errorTemplate])
  
  useEffect(()=>{
    setBodyTemplate(prev => ({...prev, descripcion: selectedCity.toLowerCase().replace(/\s+/g, '')}))
    setRealizarPeticionTemplate(!realizarPeticionTemplate)
  },[selectedCity])

  useEffect(() => {
    fetchDataTemplate()
  }, [realizarPeticionTemplate]);


  useEffect(() => {
    fetchHoteles();
    fetchHotelImages();
  }, []);

  useEffect(() => {
    if (hotelesData) {
      setHoteles(hotelesData.hoteles);
      if (selectedCityFromUrl) {
        const filteredHotels = hotelesData.hoteles.filter(
          (hotel: HotelData) => hotel.ciudad === selectedCityFromUrl
        );
        setHotelData(filteredHotels);

        setBodyTemplate(prev => ({...prev, descripcion: selectedCityFromUrl.toLowerCase().replace(/\s+/g, '')}))
        setRealizarPeticionTemplate(!realizarPeticionTemplate)

      } else {
        setHotelData(hotelesData.hoteles);
      }
    }
    if (hotelesError) {
      console.log(hotelesError);
    }
  }, [hotelesData, hotelesError]);

  useEffect(() => {
    if (hotelImagesData) {
      setHotelImages(hotelImagesData.hoteles); // Almacena las imágenes en el estado
    }
    if (hotelImagesError) {
      console.log(hotelImagesError);
    }
  }, [hotelImagesData, hotelImagesError]);

  useEffect(() => {
    if (selectedCityFromUrl && selectedCityFromUrl !== "all") {
      setSelectedCity(selectedCityFromUrl);
      filterHotelsByCity(selectedCityFromUrl);
    }
  }, [selectedCityFromUrl]);

  const filterHotelsByCity = (city: string) => {
    if (city === "all") {
      setHotelData(hoteles);
    } else {
      const filteredHotels = hoteles.filter((hotel) => hotel.ciudad === city);
      setHotelData(filteredHotels);
    }
  };

  const handleCityChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedCity = event.target.value;
    setSelectedCity(selectedCity);
    filterHotelsByCity(selectedCity);
  };

  return (
    <div
      className={`nc-SectionGridFilterCard ${className}`}
      data-nc-id="SectionGridFilterCard"
    >
      <Heading2 />
      
      <div className="flex items-center justify-between mb-10 lg:mb-5 mt-5" style={{width: '250px'}}>
        <select value={selectedCity} onChange={handleCityChange}>
          <option value="all">Todas las ciudades</option>
          {hoteles.length > 0 && hoteles.map((hotel: HotelData) => (
            <option key={hotel.ciudad} value={hotel.ciudad}>
              {hotel.ciudad}
            </option>
          ))}
        </select>
      </div>

      <div className="grid grid-cols-1 gap-6 md:gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">

        {hotelData.map((hotel) => {
          // Encuentra las imágenes del hotel actual
          const images = hotelImages.filter(img => img.hotel_code === hotel.codigo);
          
          return (
            <StayCard 
              key={hotel.codigo} 
              hotel={hotel} 
              hotelImages={images} // Pasa el array de objetos HotelImageData[]
              defaultImage={hotelImagesData?.default_image || ''}
            />
          );
        })}

         {(hotelData && hotelData.length === 1 && !errorTemplate) && 
          <div className="listingSection__wrap bg-white sm:col-span-1 lg:col-span-2 xl:col-span-3">
              
               <style>
                {`
                  h1 {
                    font-size: 2.5rem;
                    font-weight: bold;
                    color: #333;
                    margin-bottom: 1rem;
                    line-height: 1.2
                  }
                  h2 {
                    font-size: 2rem;
                    font-weight: semi-bold;
                    color: #444;
                    margin-bottom: 0.75rem;
                    line-height: 1.2
                  }
                  h3 {
                    font-size: 1.75rem;
                    font-weight: semi-bold;
                    color: #555;
                    margin-bottom: 0.5rem;
                    line-height: 1.2
                  }
                  p {
                    font-size: 1rem;
                    line-height: 1.6;
                    color: #666;
                    margin-bottom: 1rem;
                  }
                  a {
                    color: #1a73e8;
                    text-decoration: none;
                  }
                  a:hover {
                    text-decoration: underline;
                  }
                  ul, ol {
                    padding-left: 1.5rem;
                    margin-bottom: 1rem;
                  }
                  li {
                    margin-bottom: 0.5rem;
                  }
                `}
              </style>
              {
                (templateCiudad.length > 0) && 
                <div style={{margin: '0px'}} dangerouslySetInnerHTML={{ __html: templateCiudad[0]?.cuerpo || ""}} />
              }
              
          </div>}
      </div>
    </div>
  );
};

export default SectionGridFilterCard;